import { useAuth0 } from "@auth0/auth0-react";
import Pagination from "@material-ui/lab/Pagination";
import { ReactComponent as AddIconSVG, ReactComponent as PlusIcon } from "assets/icons/plus.svg";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import SearchComp from "components/Searchcomponent";
import PastoralService from "Lib/API/PastoralApi";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import AddEventType from "./AddEventType";
import EventTypeTable from "./EventTypeTable/EventTypeTable.jsx";
import "./index.scss";

const initialFilters = {
  filter: {
    search: "",
  },
};
const EventSettingPage = () => {
  const { getAccessTokenSilently } = useAuth0();

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [list, setList] = React.useState([]);
  const [eventsTotal, setEventsTotal] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [confirmClose, setConfirmClose] = useState(false);

  const openCreateEvent = (row) => {
    setOpenModal(true);
    if (row) {
      setSelectedRow(row);
    }
  };

  const closeCreateEvent = () => {
    setOpenModal(false);
    setSelectedRow(null);
  }


  const getEventTypesHandler = async (initialPage = 1) => {
    const currentPage = initialPage || page;
		if (currentPage === 1) {
			setPage(1);
		}
    setLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventTypes({ token, page:currentPage, limit: 30, search: searchValue })
      .then((res) => {
        if (res) {
          setList(res?.eventTypes);
          setEventsTotal(res?.total);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (searchValue) {
      debounceSearch();
    } else {
      getEventTypesHandler(1);
    }
    return () => debounceSearch.cancel();
  }, [searchValue]);


  const onSearchChange = (e) => {
    const { value } = e.target;
    const regex = /[\\*\(\)\+]/;
    if (!regex.test(value)) {
      setSearchValue(value);
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (searchValue) {
        getEventTypesHandler(1);
      }
    }, 500),
    [searchValue, page]
  );

  


  const closeDeleteDialog = () => {
    setSelectedRow(null);
    setConfirmDialog(false);
  }
  const openDeleteDialog = (row) => {
    setSelectedRow(row);
    setConfirmDialog(true);
  }
  const deleteEventHandler = async () => {
    const token = await getAccessTokenSilently();
    setDeleteLoading(true);
    PastoralService.deleteEventType({ id: selectedRow?.id, token })
      .then((res) => {
        toastr.success("Success", "Event Type Deleted Successfully");
        closeDeleteDialog();
        getEventTypesHandler();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  } 


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    closeCreateEvent();
  }


  return (
    <>
      <div className="event-types-setting-page">
        <div className="user__table__header mb-5">
          <div className="d-flex table-header-search">
            <SearchComp
              value={searchValue}
              setSearchText={onSearchChange}
              placeholder="Search"
              style={{ width: "20.5rem", backgroundColor: "#fff" }}
            />
          </div>
          <div className="right__section table-header-buttons">
            <Button
              variant='primary'
              onClick={() => openCreateEvent()}
              style={{ marginLeft: 10}}
              size="md"
            >
              <PlusIcon />
              <span>New Event Type</span>
            </Button>
          </div>
        </div>
        <div>
          <EventTypeTable
            loading={loading}
            eventtypeList={list}
            openEditEvent={openCreateEvent}
            deleteEvent={openDeleteDialog}
          />
        </div>
        <div className="pagination-custom mt-5">
          <Pagination
            count={Math.ceil(eventsTotal / 30)}
            color="primary"
            variant="outlined"
            page={page}
            onChange={(e, value) => {
              setPage(value);
              getEventTypesHandler(value);
            }}
          />
        </div>
        <MyModal
					className="add-task-automation-modal"
					open={openModal}
					onClose={closeModal}
				>
          <AddEventType 
            closeModal={closeModal} 
            handleClose={closeCreateEvent}
            type={selectedRow ? "edit" : "add"}
            data={selectedRow}
            fetchEvents={getEventTypesHandler}
          />
				</MyModal>
        <AlertDialog
          open={confirmDialog}
          onDecline={closeDeleteDialog}
          onAccept={() => {
            if (selectedRow?.id) {
              deleteEventHandler();
            }
          }}
          title="Are you sure?"
          description={"Do you want to delete this event type?"}
          disabled={deleteLoading}
        />
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </>
  );
};

export default EventSettingPage;
